import isArray from "lodash/isArray";

/**
 * Combines an array of strings into a comma-separated string.
 * - Filters out non-strings and empty values
 * - Trims whitespace
 */
export default function joinArrayOfStrings(arr) {
  if (!isArray(arr)) return "";

  return arr
    .filter((val) => typeof val === "string" && val.trim() !== "")
    .map((val) => val.trim())
    .join(", ");
}
